import { HomeExamResults } from './HomeExamResults';
export default HomeExamResults;
